import PendoCard from '../../components/card/pendo-card.vue.js';
import PendoEmptyState from '../../components/empty-state/pendo-empty-state.vue.js';
import PendoButton from '../../components/button/pendo-button.vue.js';
import capitalize from 'lodash/capitalize.js';

var script = {
  name: 'PendoCountableEmptyState',
  components: {
    PendoCard,
    PendoEmptyState,
    PendoButton
  },
  props: {
    countableType: {
      type: String,
      required: true
    },
    isReadOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    title() {
      return `${capitalize(this.countableType)}s`;
    },
    emptyStateTitle() {
      return `No ${this.title} Tagged`;
    },
    description() {
      return 'Tagging pages allows you to view page traffic and understand the behavior of your users.';
    },
    icon() {
      switch (this.countableType) {
        case 'page':
          return 'https://cdn.pendo.io/img/no-pages-tagged.svg';
        default:
          return '';
      }
    }
  },
  methods: {
    tagCountable() {
      this.$emit('tag-countable', true);
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-countable-empty-state.vue2.js.map
